import React, { useEffect, useState } from "react";
import "../assets/styles/components/Top.sass";
import Flag from "../assets/static/flag_bt.png";

const Top = () => {
  const [link, setLink] = useState("");

  useEffect(() => {
    const LinkSession = window.sessionStorage.getItem("menuV3");

    if (!LinkSession) {
      const LLDDLink = fetch(`https://legendofeldorado.com/2018/api/enlace-personalizado/1`);
      const CaribeLink = fetch(`https://legendofeldorado.com/2018/api/enlace-personalizado/2`);
      const SeriesManizales = fetch(`https://legendofeldorado.com/series-admin-temporal/api/enlace-personalizado/1`);

      Promise.all([LLDDLink, CaribeLink, SeriesManizales]).then(async ([lldd, caribe, seriesManizales]) => {
        const Links = {
          lldd: await lldd.json(),
          caribe: await caribe.json(),
          seriesManizales: await seriesManizales.json(),
        };

        setLink(Links);
        try {
          window.sessionStorage.setItem("menuV3", JSON.stringify(Links));
        } catch (error) {
          return console.log(error);
        }
      });
    }
    setLink(JSON.parse(LinkSession));
  }, []);

  return (
    <div className="row">
      <div className="col-12 Top">
        <div className="d-block d-lg-none">
          <a id="menu_mobil" href="#my-menu">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32px"
              height="25px"
              viewBox="0 0 32 32"
            >
              <rect x="1.599" y="1.731" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="13" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="24.268" fill="#000" width="28.803" height="4" />
            </svg>
          </a>
        </div>
        <div className="Top-logo">
          <a href="/series">
            <span className="Top-logo-lldd"></span>
          </a>
        </div>
        <div className="Top-main-menu d-none d-lg-block">
          <nav>
            <ul className="Top-menu">
              <li className="Top-lldd">
                <a href="https://legendofeldorado.com/">
                  LA LEYENDA <br /> DEL DORADO
                </a>
                <div className="Top-lldd-container">
                  <div className="Top-lldd-container-wrap">
                    <b>LA LEYENDA DEL DORADO - CARRERA MTB DE 7 ETAPAS</b>
                    <div className="Top-lldd-grid">
                      <div className="Top-lldd-itema">
                        <a className="Top-lldd-link --red" href={link?.lldd?.url_es}>
                          {link?.lldd?.title_es}
                        </a>
                      </div>
                      <div className="Top-lldd-itemb">
                        <a className="Top-lldd-link" href="https://legendofeldorado.com/contact-us">
                          CONTÁCTENOS
                        </a>
                      </div>
                      <div className="Top-lldd-itemc">
                        <p className="text-yellow">INICIO</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/">- La Leyenda Resumen</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/packages">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/prices">- Precios</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/payment">- Plan de pagos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/categories">- Categorías</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/testimonials">- Testimonios</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/no-excuses">- No hay excusas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/home/news">- Últimas noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemd">
                        <p className="text-yellow">ACERCA DE LA CARRERA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/about-us/race_overview">- Descripción de la carrera</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/packages-upgrades">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/categories_and_prizes">- Categorías & Premios</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/charity-entries">- Registros de fundaciones</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/payment-options">- Opciones de pago</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/rules">- Reglamento</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/social-responsibility">- Responsabilidad social</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/safety_and_security">- Seguridad</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/travel">- Viajar</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/about-us/tours">- Tours</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-iteme">
                        <p className="text-yellow">RUTA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/route/2016/summary">- 2016 Guaduas a Retiro</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2017/summary">- 2017 Caldas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2018/summary">- 2018 Caldas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2019/summary">- 2019 Caldas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2022/summary">- 2022 Valle del Cauca</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2023/summary">- 2023 Caldas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/route/2024">- 2024 Información</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemf">
                        <p className="text-yellow">CORREDORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/racers/what_to_pack">- Qué empacar</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/racers/daily_schecdule">- Horario diario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/racers/tips-and-tricks">- Consejos y trucos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/racers/jaguares">- Jaguares</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/racers/training">- Entrenamiento</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/results">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemg">
                        <p className="text-yellow">PATROCINADORES Y COLABORADORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/sponsors-and-partner">- Patrocinadores y colaboradores</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/sponsors-and-partner/become-a-sponsor">
                              - Conviértete en patrocinador
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/sponsors-and-partner/expo-information">
                              - Información de la expo
                            </a>
                          </li>
                        </ul>
                        <p className="mt-4 d-block text-yellow">NOTICIAS & MEDIOS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/latest-news">- Últimas noticias</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/gallery">- Galería</a>
                          </li>
                          <li>
                            <a
                              href="https://www.youtube.com/channel/UCY4v-WN-1st7I9OjU2ZZXVw"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              - Videos
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/news-and-media/press">- Prensa</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/news-and-media/newsletters">- Boletín de noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemh">
                        <p className="text-yellow">PREGUNTAS FRECUENTES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://legendofeldorado.com/faqs/race-info">- Info de la carrera</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/logistics">- Logistica</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/registration">- Registro</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/services">- Servicios</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/accommodation">- Alojamiento</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/equipment">- Equipamento</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/insurance">- Seguro</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/cancelation-refunds">- Cancelación y reembolsos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/faqs/supporters">- Acompañantes</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-aruba">
                <a href="https://www.aruba-la-leyenda.com/">
                  LA LEYENDA <br /> ARUBA
                </a>
              </li>
              <li className="Top-caribe">
                <a href="https://legendofeldorado.com/caribe/">
                  LA LEYENDA <br /> DEL CARIBE
                </a>
                <div className="Top-caribe-container">
                  <div className="Top-caribe-container-wrap">
                    <b> LA LEYENDA DEL CARIBE - CARRERA MTB DE 5 ETAPAS - REPÚBLICA DOMINICANA</b>
                    <div className="Top-caribe-grid">
                      <div className="Top-caribe-itema">
                        <a className="Top-caribe-link" href={link?.caribe?.url_es}>
                          {link?.caribe?.title_es}
                        </a>
                      </div>
                      <div className="Top-caribe-itemb">
                        <a className="Top-caribe-link" href="https://legendofeldorado.com/caribe/contactanos">
                          CONTÁCTENOS
                        </a>
                      </div>
                      <div className="Top-caribe-itemc">
                        <p>INICIO</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <a href="https://legendofeldorado.com/caribe/">- Leyenda Caribe Resumen</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/caribe/paquetes-y-ascensos">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/caribe/precios">- Precios</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/caribe/categorias-y-premiacion">
                              - Categorías y Premiación
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/caribe/rutas-y-reglamentacion/resumen">
                              - Rutas y Reglamentación
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/caribe/patrocinio">- Patrocinio</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemd"></div>
                      <div className="Top-caribe-iteme"></div>
                      <div className="Top-caribe-itemf"></div>
                      <div className="Top-caribe-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-series">
                <a href="/series">
                  LA LEYENDA <br /> SERIES
                </a>
                <div className="Top-series-container">
                  <div className="Top-series-container-wrap">
                    <b>LA LEYENDA SERIES - EVENTOS MTB DE 1 DÍA</b>
                    <div className="Top-series-grid">
                      <div className="Top-series-itema">
                        <a className="Top-series-link" href="/series">
                          INICIO
                        </a>
                      </div>
                      <div className="Top-series-itemb">
                        <a className="Top-series-link" href="/series/contactenos">
                          CONTACTANOS
                        </a>
                      </div>
                      <div className="Top-series-itemc">
                        <p>MANIZALES 2024</p>
                        <ul className="Top-series-list">
                          {/* <li>
                            <a href={link?.seriesManizales?.url_es} target="blank">
                              - {link?.seriesManizales?.title_es}
                            </a>
                          </li> */}
                          <li>
                            <a href="/series/manizales/acerca-de-la-carrera">- Series Manizales resumen</a>
                          </li>
                          <li>
                            <a href="/series/manizales/precios-que-incluye">- Precios y qué incluye</a>
                          </li>
                          <li>
                            <a href="/series/manizales/carrera-manizales">- Rutas</a>
                          </li>
                          <li>
                            <a href="/series/manizales/categorias">- Categorías</a>
                          </li>
                          <li>
                            <a href="/series/manizales/premiacion-y-reglamento">- Premiación y reglamento</a>
                          </li>
                          <li>
                            <a href="/series/manizales/patrocinio-expo">- Patrocinio y expo</a>
                          </li>
                          <li>
                            <a href="/series/manizales/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="/series/manizales/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemd">
                        <p>CALDAS 2022</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="/series/caldas/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="/series/caldas/acerca-de-la-carrera">- Series Caldas resumen</a>
                          </li>
                          {/* <li>
                            <a href="/series/caldas/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="/series/caldas/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="/series/caldas/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="/series/caldas/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="/series/caldas/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="/series/caldas/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-iteme">
                        <p>CALI 2021</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="/series/cali/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="/series/cali/acerca-de-la-carrera">- Series Cali resumen</a>
                          </li>
                          {/* <li>
                            <a href="/series/cali/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="/series/cali/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="/series/cali/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="/series/cali/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="/series/cali/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="/series/cali/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemf"></div>
                      <div className="Top-series-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-adventures">
                <a href="https://legendofeldorado.com/adventures/">
                  LA LEYENDA <br /> ADVENTURES
                </a>
                <div className="Top-adventures-container">
                  <div className="Top-adventures-container-wrap">
                    <b>LA LEYENDA ADVENTURES - EXPERIENCIAS EN CICLISMO DE LUJO, ORGANIZADAS POR EXPERTOS</b>
                    <div className="Top-adventures-grid">
                      <div className="Top-adventures-itema">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures">
                          INICIO
                        </a>
                      </div>
                      <div className="Top-adventures-itemb">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures/contact-us">
                          CONTÁCTANOS
                        </a>
                      </div>
                      <div className="Top-adventures-itemc">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures/custom-tour">
                          AVENTURA PERSONALIZADO
                        </a>
                      </div>
                      <div className="Top-adventures-itemd"></div>
                      <div className="Top-adventures-iteme">
                        <p>
                          AVENTURA DEL CAFÉ <span>MTB - Pereira a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --coffee">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/tour-overview">- Acerca del tour</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/coffee-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemf">
                        <p>
                          AVENTURA ANTIOQUIA <span>MTB - Medellin a Medellin</span>
                        </p>
                        <ul className="Top-adventures-list --antioquia">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/tour-overview">
                              - Acerca del tour
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/antioquia-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemg">
                        <p>
                          AVENTURA VOLCÁN <span>MTB - Bogotá a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --volcano">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/tour-overview">- Acerca del tour</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/volcano-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="Top-redes">
          <a href="https://legendofeldorado.com/series/en">
            <img className="img-responsive" src={Flag} alt="Idioma Español" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Top;
